import { ChangeDetectionStrategy, Component, inject, Injector, input, OnInit, Signal } from '@angular/core';
import { Page } from 'src/app/@common/entities/page.interface';
import { ItemsViewService } from 'src/app/@domain/items-view/items-view.service';
import { PlaylistService } from 'src/app/@domain/playlist/application/playlist.service';
import { computedAsync } from '../../../../../../@common/rxjs/computed-async';
import { toNumber } from '../../../../../../@common/util/to-number';

import { PlaylistInfo } from '../../../../../../@generated';
import { PaginationComponent } from '../../../../global/pagination/pagination.component';
import { SpinnerComponent } from '../../../../global/spinner/spinner.component';
import { CardGridComponent } from '../../../card-grid/card-grid.component';
import { PlaylistItemComponent } from '../../playlist-item/playlist-item.component';

@Component({
    selector: 'app-user-playlist',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ PlaylistItemComponent, PaginationComponent, SpinnerComponent, CardGridComponent ],
    styles: `
        :host {
            position: relative;
            flex: 1;
            display: flex;
            flex-direction: column;
        }
    `,
    template: `
        @if (playlistPage(); as page) {
            <app-card-grid [listView]="!isGridView()">
                @for (playlist of page.results; track playlist) {
                    <app-playlist-item [playlist]="playlist" [listView]="!isGridView()"/>
                }
            </app-card-grid>

            @if (page.results.length) {
                <app-pagination [totalItems]="playlistPage()!.count" [pageSize]="pageSize"/>
            }
        }


        @if (!playlistPage()) {
            <app-spinner/>
        }

    `
})
export class UserPlaylistComponent implements OnInit {
    private playlistService = inject(PlaylistService);
    private itemsViewService = inject(ItemsViewService);
    private injector = inject(Injector);

    public page = input(1, { transform: toNumber(1) });
    public isGridView = this.itemsViewService.isGridView;
    public playlistPage!: Signal<Page<PlaylistInfo> | undefined>;
    public pageSize = 8;

    public ngOnInit() {
        this.playlistPage = computedAsync(
            () => this.playlistService.getPlaylists(this.page(), this.pageSize),
            { injector: this.injector }
        );
    }
}
